<div class="vision-form">
  <h3 class="vision-form__title">{{ 'organization_unit.vision.title' | translate }}</h3>
  <p class="vision-form__description">{{ 'organization_unit.vision.description' | translate }}</p>

  @if (notApplicable) {
    <p class="vision-form__not-applicable">{{ 'organization_unit.vision.not_applicable' | translate }}</p>
  } @else {
    <div class="vision-form__column">
      <mat-form-field appearance="outline" class="vision-form__field">
        <mat-label>{{ 'organization_unit.vision.label' | translate }}</mat-label>
        <textarea
          matInput
          rows="6"
          [formControl]="visionControl"
          [readonly]="loading"
          [attr.placeholder]="'organization_unit.vision.placeholder' | translate"
        ></textarea>
      </mat-form-field>

      @if (canEdit) {
        <div class="vision-form__actions">
          <!-- Shown whenever something is stored, disabled rather than removed
               while a fetch is in flight, so the row does not jump. -->
          @if (hasStoredVision) {
            <button mat-stroked-button type="button" [disabled]="!canClear" (click)="clear()">
              {{ 'organization_unit.vision.clear' | translate }}
            </button>
          }
          <button mat-flat-button color="primary" type="button" [disabled]="!canSave" (click)="save()">
            {{ 'generic.save' | translate }}
          </button>
        </div>
      }
    </div>
  }
</div>
